"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _component = _interopRequireDefault(require("./component"));

var _attach = _interopRequireDefault(require("./attach"));

var _formCardButtons = _interopRequireDefault(require("./form-card-buttons"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    paper: {
      margin: theme.spacing(1),
      padding: theme.spacing(2)
    },
    content: {
      flex: 1,
      cursor: 'pointer'
    }
  };
}; // Use PureComponent so that we avoid unnecessary re-rendering


var FormCard = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FormCard, _React$PureComponent);

  var _super = _createSuper(FormCard);

  function FormCard() {
    var _this;

    (0, _classCallCheck2.default)(this, FormCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.component);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEdit", function (event, id) {
      if (_this.props.onEdit) {
        _this.props.onEdit(event, _this.props.component);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDelete", function (event) {
      // this.handleMoreClose();
      if (_this.props.onDelete) {
        _this.props.onDelete(_this.props.component);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          component = _this$props.component,
          forbidUpdate = _this$props.forbidUpdate,
          forbidDelete = _this$props.forbidDelete,
          editable = _this$props.editable,
          disabled = _this$props.disabled,
          value = _this$props.value,
          buttons = _this$props.buttons,
          id = _this$props.id;
      var cardButtons;

      if (buttons) {
        cardButtons = /*#__PURE__*/_react.default.createElement(_component.default, {
          component: buttons
        });
      } else {
        cardButtons = /*#__PURE__*/_react.default.createElement(_formCardButtons.default, {
          forbidUpdate: forbidUpdate,
          forbidDelete: forbidDelete,
          editable: editable,
          disabled: disabled,
          archivedAt: value.archivedAt,
          onEdit: function onEdit(event) {
            return _this2.handleEdit(event);
          },
          onDelete: function onDelete(event) {
            return _this2.handleDelete(event);
          },
          id: id
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Paper.default, {
        className: classes.paper
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        wrap: "nowrap"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        className: classes.content,
        onClick: function onClick(event) {
          return _this2.handleClick(event);
        },
        role: "button",
        "aria-label": this.props['aria-label'],
        id: id
      }, /*#__PURE__*/_react.default.createElement(_component.default, {
        component: component,
        formTag: false,
        mode: "read"
      })), cardButtons)));
    }
  }]);
  return FormCard;
}(_react.default.PureComponent);

FormCard = (0, _withStyles.default)(styles)(FormCard);

var _default = (0, _attach.default)(['value'])(FormCard);

exports.default = _default;